import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ResetOrgUserPasswordRequest } from '../org-user.model';
import { TEMP_PASSWORD_REQUIREMENT_ITEMS } from '../org-user.util';

export type ResetOrgUserPasswordDialogData = {
  email: string;
};

@Component({
  selector: 'app-reset-org-user-password-dialog',
  standalone: true,
  imports: [MaterialModule, ReactiveFormsModule, MatDialogModule],
  templateUrl: './reset-org-user-password-dialog.component.html',
  styleUrl: './reset-org-user-password-dialog.component.scss',
})
export class ResetOrgUserPasswordDialogComponent {
  #dialogRef = inject(MatDialogRef<ResetOrgUserPasswordDialogComponent, ResetOrgUserPasswordRequest>);
  data: ResetOrgUserPasswordDialogData = inject(MAT_DIALOG_DATA);

  hidePassword = true;
  passwordRequirementItems = TEMP_PASSWORD_REQUIREMENT_ITEMS;

  form = new FormGroup({
    email: new FormControl({ value: this.data.email, disabled: true }),
    temporaryPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
  });

  get temporaryPassword() {
    return this.form.controls.temporaryPassword;
  }

  getPasswordErrorMessage(): string {
    if (this.temporaryPassword.hasError('required')) {
      return 'You must enter a temporary password';
    }
    if (this.temporaryPassword.hasError('minlength')) {
      return 'Temporary password must be at least 8 characters';
    }
    return 'You must enter a valid temporary password';
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }

    this.#dialogRef.close({
      temporaryPassword: this.temporaryPassword.value!,
    });
  }
}
